import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MethodsHelper } from '@app/helpers/methods.helper';
import { Account } from '@app/models/account';
import { AccountType } from '@app/models/account-type';
import { LinkedAccountItem } from '@app/models/linked-account-item';

@Component({
    selector: 'app-linked-account-input',
    templateUrl: './linked-account-input.component.html',
    styleUrls: ['./linked-account-input.component.css'],
    standalone: false
})
export class LinkedAccountInputComponent implements OnChanges {

  @Input() accountList: Account[];
  @Input() accountTypeList: AccountType[];
  @Input() account: string;
  @Input() accountType: string;
  @Input() accountId: string;
  @Input() accountNumber: string;
  @Input() accountTypeCode: string;
  @Input() accountInputValue: string;
  @Input() loadAccount: boolean;
  @Input() allowSelectAccountType: boolean;
  @Output() onChangeValue = new EventEmitter<LinkedAccountItem>();
  @Output() onCancel = new EventEmitter();
  @Output() onChangeValidation = new EventEmitter<boolean>();

  selectedAccount: any;

  displayAccountPopup: boolean = false;
  selectedLinkedAccount: LinkedAccountItem;

  errorMessage: string;
  orignalAccountInputValue: string;

  constructor() { }

  ngOnChanges(): void {
    this.orignalAccountInputValue = this.accountInputValue;
  }

  addAccount(account) {
    if (account) {
      this.selectedAccount = account;
    }
    this.closeAccountsModal();
  }

  openAccountsModal(event) {

    event.stopPropagation();

    this.selectedAccount = new LinkedAccountItem();
    if (this.loadAccount) {
      this.selectedAccount.account = this.account;
      this.selectedAccount.type = this.accountType;
      this.selectedAccount.id = this.accountId;
      this.selectedAccount.number = this.accountNumber;
      this.selectedAccount.typeCode = this.accountTypeCode;
      this.selectedAccount.inputValue = this.accountInputValue;
    } else {
      this.selectedAccount.typeCode = this.accountTypeCode;
      this.selectedAccount.inputValue = this.accountInputValue;
    }

    this.displayAccountPopup = true;
  }

  closeAccountsModal() {
    this.displayAccountPopup = false;
    this.orignalAccountInputValue = this.selectedAccount.inputValue;
    this.errorMessage = "";
    this.sendBackCorrectValue();
  }

  clearSelectedAccount() {
    this.displayAccountPopup = false;
    this.selectedAccount = new LinkedAccountItem();
  }

  composeAccountType(accountType: AccountType) {
    let item = new LinkedAccountItem();
    item.type = true;
    item.number = null;
    item.id = null;
    item.typeCode = accountType.code;
    item.inputValue = accountType.code;
    return item;
  }

  composeAccount(account: Account) {
    if (account) {
      let item = new LinkedAccountItem();
      item.account = true;
      item.number = account.number;
      item.id = account.id;
      item.typeCode = null;
      item.inputValue = account.number;
      return item;
    }
    return undefined;
  }

  sendBackCorrectValue() {
    this.onChangeValidation.emit(true);
    this.onChangeValue.emit(this.selectedAccount);
  }

  checkValueIfExist() {
    if (this.orignalAccountInputValue != this.accountInputValue) {
      this.orignalAccountInputValue = this.accountInputValue;
      this.errorMessage = "";
      if (MethodsHelper.haveValue(this.accountInputValue)) {
        if (this.loadAccount) {
          this.checkDataFromAccount();
        } else {
          this.checkDataFromAccountType();
        }
      } else {
        this.selectedAccount = new LinkedAccountItem();
        this.sendBackCorrectValue();
      }
    }
  }

  checkDataFromAccountType() {
    if (this.accountTypeList && this.accountTypeList.length > 0) {
      let item = this.accountTypeList.find(p => p.code == this.accountInputValue);
      if (item) {
        this.selectedAccount = this.composeAccountType(item);
        this.sendBackCorrectValue();
        return;
      }
    }
    this.errorMessage = "Account number is not existed";
    this.onChangeValidation.emit(false);
  }

  checkDataFromAccount() {
    if (this.accountList && this.accountList.length > 0) {
      let item = this.accountList.find(p => p.number == this.accountInputValue);
      if (item) {
        this.selectedAccount = this.composeAccount(item);
        this.sendBackCorrectValue();
        return;
      }
    }
    this.checkDataFromAccountType();
  }
  
}
